import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedOrganisation: cacheLs.get_organisation()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
